import React from 'react'

const FailedPage = () => {
  return (
    <div>FailedPage</div>
  )
}

export default FailedPage